import classNames from 'classnames';
import moment from 'moment';
import styles from './Change.module.css';
import formatNumber from "../../utils/formatNumber";

const PreviousOrNewValue = (props) => {
	if(props.type === 'name'){
		return (
			<span className={styles.bold}>"{props.value}"</span>
		)
	}
	if(props.type === 'description'){
		return (
			<span className={styles.link} onClick={() => {
				props.setViewDescriptionText(props.value);
				props.setShowViewDescriptionModal(true);
			}}>{props.value.substring(0, 50)}{props.value.length > 50 ? '...' : ''}</span>
		)
	}
	if(props.type === 'end_at'){
		return (
			<span className={styles.bold}>{moment(props.value).format('MMMM D, YYYY')}</span>
		)
	}
	if(props.type === 'goal_amount'){
		return (
			<span className={styles.bold}>${formatNumber(props.value)}</span>
		)
	}
};

const Change = (props) => {
	let typeText;
	if(props.change?.type === 'name'){
		typeText = 'Name';
	}
	else if(props.change?.type === 'description'){
		typeText = 'Description';
	}
	else if(props.change?.type === 'end_at'){
		typeText = 'End date';
	}
	else if(props.change?.type === 'goal_amount'){
		typeText = 'Fundraiser goal';
	}

	return (
        <div className={classNames(styles.container, props.className)} style={props.style}>
            <div className={styles.topRow}>
                <div>
                    {
                        props.index === 0 && (
                            <div className={styles.borderCover}/>
                        )
                    }
                    <div className={styles.outerCircle}>
                        <div className={styles.innerCircle}/>
                    </div>
                </div>
				<div className={styles.text}>
                    <span className={styles.bold}>
						{typeText}
					</span> changed from <PreviousOrNewValue type={props.change?.type} value={props.change?.previous_value}
															 setShowViewDescriptionModal={props.setShowViewDescriptionModal}
															 setViewDescriptionText={props.setViewDescriptionText}/> to <PreviousOrNewValue type={props.change?.type}
																																			value={props.change?.new_value}
																																			setShowViewDescriptionModal={props.setShowViewDescriptionModal}
																																		    setViewDescriptionText={props.setViewDescriptionText}/>
				</div>
			</div>
			<div className={styles.middleRow}>
				<div className={styles.datetime}>
                    {moment(props.change?.created_at).format('MMMM D, YYYY h:mma')}
                </div>
            </div>
        </div>
    )
};

export default Change;